/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';

export const AuthorImageStyle = {
  width: 50,
  height: 50,
};

export const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ColContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
